/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneBox as ResolvedStandaloneBox } from 'base/components/standalone/Box';

export const Box: typeof ResolvedStandaloneBox = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneBox {...props} />
        </ErrorBoundary>
    );
});

export type BoxProps = PropsFromComponent<typeof Box>;

/** @deprecated Use slot architecture instead */
export const BoxWith = (extras: DynamicStandaloneExtras): typeof Box => {
    return function Box(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Box');
        return <ResolvedStandaloneBox {...mergeProps({ options: { theme } }, props)} />;
    }
}